import React, { useEffect, useState } from "react";
import Player from "@vimeo/player";
import { calculateHeight } from "./utils";
import * as S from "./styles";

let playerGeneral = null;

const buildPlayer = (id, vimeoID) => {
    const height = calculateHeight();

    let options = {
        id: vimeoID,
        title: false
    };

    if (height <= 350) {
        options.height = height;
    }

    return new Player(id, options);
};

const VimeoPlayer = ({
                         id = "vimeo-selector",
                         onListen,
                         onCreate,
                         virtualFinishAt,
                         onVirtualFinish,
                         tokens,
                         loading
                     }) => {
    const [firedVirtualFinish, setFiredVirtualFinish] = useState(false);
    const [listenEvent, setLastListenEvent] = useState({});
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
    }, [loading]);

    useEffect(() => {
        if (!listenEvent.seconds) return;

        if (onListen) {
            onListen({
                duration: listenEvent.duration,
                seconds: listenEvent.seconds
            });
        }

        if (onVirtualFinish && virtualFinishAt && !firedVirtualFinish) {
            if (listenEvent.percent * 100 > virtualFinishAt) {
                setFiredVirtualFinish(true);
                onVirtualFinish();
            }
        }
    }, [listenEvent]);

    useEffect(() => {
        if (tokens.vimeo) {
            playerGeneral = buildPlayer(id, tokens.vimeo);
            if (playerGeneral) {
                playerGeneral.loadVideo(tokens.vimeo);
            }

            if (onCreate) {
                onCreate({
                    play: playerGeneral.play.bind(playerGeneral),
                    pause: playerGeneral.pause.bind(playerGeneral),
                    seek: playerGeneral.setCurrentTime.bind(playerGeneral)
                });
            }

            if (onVirtualFinish && virtualFinishAt) {
                playerGeneral.on("timeupdate", function (event) {
                    setLastListenEvent({
                        duration: event.duration,
                        seconds: event.seconds,
                        percent: event.percent
                    });
                });
            }
            setLoaded(true);
        }
    }, [tokens.vimeo]);

    return (
        <S.VideoPlayer style={{ height: calculateHeight() }}>
            <S.VimeoEmbed id={id}/>
            {/* Placeholder pra quando a pagina eh carregada */}
            {!loaded ? <div style={{ height: calculateHeight() }}/> : null}
        </S.VideoPlayer>
    );
};

export default VimeoPlayer;
